import { SubscriptionState } from '@batical/types/src'
import { getFirestore, doc, getDoc, updateDoc, setDoc } from 'firebase/firestore'
import { getApp } from 'firebase/app'

export async function firestoreSubscriptionData(uid: string) {
  const firestore = getFirestore(getApp())
  try {
    const docRef = doc(firestore, 'subscription', uid)
    const documentSnapshot = await getDoc(docRef)
    if (documentSnapshot.exists()) {
      return documentSnapshot.data() as SubscriptionState
    } else {
      await setDoc(docRef, {
        expirationDate: 0,
        expirationDateStripe: 0,
        expirationDateDistributor: 0,
        isAndroid: false,
        isIos: false,
        isStripe: false,
        isDistributor: false,
        offerBy: '',
        offerBySubscriptionId: ''
      })
      return {
        expirationDate: 0,
        expirationDateStripe: 0,
        expirationDateDistributor: 0,
        isAndroid: false,
        isIos: false,
        isStripe: false,
        isDistributor: false,
        offerBy: '',
        offerBySubscriptionId: ''
      } as SubscriptionState
    }
  } catch {
    return null
  }
}
/**
 * It gets the Stripe config from Firestore.
 * @param {string} uid - The user ID of the user who is subscribing.
 * @param data - { [key: string]: string | number | boolean }
 */

export async function updateFirestoreSubscriptionData(uid: string, data: { [key: string]: string | number | boolean }) {
  const firestore = getFirestore(getApp())
  const docRef = doc(firestore, 'subscription', uid)
  return await updateDoc(docRef, data)
}

export async function setFirestoreSubscriptionData(uid: string, data: { [key: string]: string | number | boolean }) {
  const firestore = getFirestore(getApp())
  const docRef = doc(firestore, 'subscription', uid)
  return await setDoc(docRef, data)
}

export async function getFirestoreStripeConfig(userId: string) {
  const firestore = getFirestore(getApp())
  let docRef = doc(firestore, 'stripe', userId)
  let documentSnapshot = await getDoc(docRef)
  if (documentSnapshot.exists()) {
    return documentSnapshot.data()
  }
  docRef = doc(firestore, 'stripe', 'default')
  documentSnapshot = await getDoc(docRef)
  if (documentSnapshot.exists()) {
    return documentSnapshot.data()
  }
  return null
}

export async function isSubscriptionStripeStillActive(uid: string) {
  const res = await firestoreSubscriptionData(uid)
  if (res) {
    const stripeSubId = res.stripeSubscriptionId
    if (stripeSubId) {
      const firestore = getFirestore(getApp())
      try {
        const docRef = doc(firestore, 'stripeSubscriptions', stripeSubId)
        const documentSnapshot = await getDoc(docRef)
        const data = documentSnapshot.data()

        if (data && data.status === 'active') {
          return true
        }
        return false
      } catch {
        return false
      }
    }
  }
  return false
}

export async function groupSubscriptionInfo(userId: string) {
  try {
    const firestore = getFirestore(getApp())
    const groupSubRef = doc(firestore, 'subscription', userId, 'groupSubscription', 'data')
    const documentSnapshot = await getDoc(groupSubRef)
    const data = documentSnapshot.data()
    return data
  } catch {
    return null
  }
}

//use only patching and setting a new user
// export function setGroupSubscriptionInfo(userId: string, data, store) {
//   return new Promise((resolve, reject) => {
//     const batch = store.batch()
//     const profileRef = store.doc(`groupSubscription/${userId}`)
//     batch.set(profileRef, data)
//     batch
//       .commit()
//       .then(() => {
//         resolve()
//       })
//       .catch(error => reject(error))
//   })
// }

// export function configureGroupSubscription(userId, mails, typeSubscription, functions) {
//   let callFunction = functions.httpsCallable('configureGroupSubscription')
//   return new Promise((resolve, reject) => {
//     callFunction({
//       uuid: userId,
//       mails: mails,
//       type: typeSubscription,
//       time: moment().add(1, 'M').format('x')
//     })
//       .then(result => {
//         if (result.data.success) {
//           resolve(result.data)
//         } else {
//           reject(result.data.error)
//         }
//       })
//       .catch(error => {
//         console.log(error)
//         reject(error)
//       })
//   })
// }

// export function groupSubscriberInfo(
//   authUserId: string,
//   store: any
// ): Promise<Array<{ id: string; mail: string; subscriptionProviderEndDate: string; type: number }>> {
//   return new Promise(resolve => {
//     store
//       .collection('groupSubscription')
//       .doc(authUserId)
//       .get()
//       .then(doc => {
//         if (!doc) {
//           resolve(null)
//         } else if (!doc.data()) {
//           resolve(null)
//         } else {
//           resolve(doc.data())
//         }
//       })
//   })
// }

// export function suspendOneGroupSubscription(authUserId: string, targetId: string, functions: any): Promise<> {
//   let callFunction = functions.httpsCallable('suspendOneGroupSubscription')
//   return new Promise((resolve, reject) => {
//     console.log('caling', authUserId, targetId)
//     callFunction({
//       uuid: authUserId,
//       targetId: targetId
//     })
//       .then(result => {
//         console.log(result)
//         resolve()
//       })
//       .catch(error => {
//         reject(error)
//       })
//   })
// }
